<app-nav-header></app-nav-header>
    <router-outlet></router-outlet>
<app-footer></app-footer>